import { formatAnswers, updateAnswers } from '../../lib/answers';
import { isAnsweredCorrectlyOnFirstTry } from '../../services/activities';
import {
  READING_ACTION_TYPES,
  ACTIVITY_ACTION_TYPES,
  EVIDENCE_TAGGING_ACTION_TYPES,
  POST_READING_ACTION_TYPES,
  GRAPHIC_ORGANIZER_ACTION_TYPES,
} from '../actions/action_types';

export const initialState = {
  inlineActivities: [],
  postReading: [],
  graphicOrganizer: [],
  evidenceTagging: [],
  inlineActivitiesCount: 0,
  postReadingCount: 0,
  graphicOrganizerCount: 0,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case READING_ACTION_TYPES.SET_BOOK_STATE: {
      const { activityAnswers, postReadingAnswers, graphicOrganizerAnswers, evidenceTaggingAnswers } = payload;

      return {
        ...state,
        inlineActivities: formatAnswers(activityAnswers, 'activityId'),
        postReading: formatAnswers(postReadingAnswers, 'questionId'),
        graphicOrganizer: formatAnswers(graphicOrganizerAnswers, 'graphicOrganizerId'),
        evidenceTagging: formatAnswers(evidenceTaggingAnswers, 'activityId'),
      };
    }

    case ACTIVITY_ACTION_TYPES.ANSWER: {
      const { inlineActivities } = state;
      const newAnswer = payload;

      return { ...state, inlineActivities: updateAnswers(inlineActivities, 'activityId', newAnswer) };
    }

    case EVIDENCE_TAGGING_ACTION_TYPES.ANSWER: {
      const { evidenceTagging } = state;
      const newAnswer = payload;

      return { ...state, evidenceTagging: updateAnswers(evidenceTagging, 'activityId', newAnswer) };
    }

    case POST_READING_ACTION_TYPES.ANSWER: {
      const { postReading } = state;
      const newAnswer = payload;

      return { ...state, postReading: updateAnswers(postReading, 'questionId', newAnswer) };
    }

    case GRAPHIC_ORGANIZER_ACTION_TYPES.ANSWER: {
      const { graphicOrganizer } = state;
      const newAnswer = payload;

      return { ...state, graphicOrganizer: updateAnswers(graphicOrganizer, 'graphicOrganizerId', newAnswer) };
    }

    case ACTIVITY_ACTION_TYPES.SET_ACTIVITIES:
      return { ...state, inlineActivitiesCount: payload.length };

    case POST_READING_ACTION_TYPES.SET_ALL_QUESTIONS:
      return { ...state, postReadingCount: payload.length };

    case GRAPHIC_ORGANIZER_ACTION_TYPES.SET_QUESTIONS:
      return { ...state, graphicOrganizerCount: payload.length };

    case READING_ACTION_TYPES.SHOW_UNANSWERED_QUESTIONS: {
      const { inlineActivities, postReading, graphicOrganizer, evidenceTagging } = state;

      const correctlyAnsweredActivities = inlineActivities.filter(answer =>
        isAnsweredCorrectlyOnFirstTry({ ...answer, attemptsBase: 0 }),
      );
      const correctlyAnsweredPostReading = postReading.filter(isAnsweredCorrectlyOnFirstTry);
      const correctlyAnsweredGraphicOrganizer = graphicOrganizer.filter(isAnsweredCorrectlyOnFirstTry);
      const correctlyAnsweredEvidenceTagging = evidenceTagging.filter(isAnsweredCorrectlyOnFirstTry);

      return {
        ...state,
        inlineActivities: correctlyAnsweredActivities,
        postReading: correctlyAnsweredPostReading,
        graphicOrganizer: correctlyAnsweredGraphicOrganizer,
        evidenceTagging: correctlyAnsweredEvidenceTagging,
      };
    }

    case READING_ACTION_TYPES.CLOSE_BOOK:
      return initialState;

    default:
      return state;
  }
};
